import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=0da7bc54&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=0da7bc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da7bc54",
  null
  
)

export default component.exports